var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66735 16.1061C9.25604 15.7376 8.62383 15.7722 8.25526 16.1835C7.88669 16.5948 7.92134 17.227 8.33265 17.5956L9.66735 16.1061ZM13.0723 20.5L12.4049 21.2447L13.0723 21.8427L13.7396 21.2447L13.0723 20.5ZM22.6674 13.2447C23.0787 12.8762 23.1133 12.244 22.7447 11.8326C22.3762 11.4213 21.744 11.3867 21.3326 11.7553L22.6674 13.2447ZM8.33265 17.5956L12.4049 21.2447L13.7396 19.7553L9.66735 16.1061L8.33265 17.5956ZM13.7396 21.2447L22.6674 13.2447L21.3326 11.7553L12.4049 19.7553L13.7396 21.2447Z",
    fill: "#557AE7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#557AE7",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPros);
export default __webpack_public_path__ + "static/media/pros.1c9ad9ff3cf3d727af7e92b37d77f982.svg";
export { ForwardRef as ReactComponent };